import React, { Suspense } from "react";
import { Button } from "@/components/ui/button";
import { LoadingState } from "../layout/LoadingState";
import { ComponentErrorBoundary } from "../error-boundary/ComponentErrorBoundary";
import { PreviewGallery } from "../preview/PreviewGallery";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const PersonalDashboard = () => {
  return (
    <div className="space-y-8 animate-fade-in">
      <ComponentErrorBoundary componentName="Preview Gallery">
        <Suspense fallback={<LoadingState />}>
          <PreviewGallery />
        </Suspense>
      </ComponentErrorBoundary>

      <ComponentErrorBoundary componentName="Daily Activities">
        <Suspense fallback={<LoadingState />}>
          <Card>
            <CardHeader>
              <CardTitle>Daily Activities</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">Track your daily health activities and progress.</p>
            </CardContent>
          </Card>
        </Suspense>
      </ComponentErrorBoundary>

      <div className="text-center">
        <Button size="lg">Take New Assessment</Button>
      </div>
    </div>
  );
};